module.exports = __webpack_public_path__ + "img/cliente09.51e16abd.jpg";